module.exports = __webpack_public_path__ + "img/orderCourse.8b9293e8.svg";